import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import { formatThousands } from "@/utils/index.js";
import util from "@/libs/util";
import SourceTag from "@/views/quarter/components/SourceTag.vue";
export default {
  name: 'RefundDepositModal',
  components: {
    SourceTag: SourceTag
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    title: String,
    content: String,
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    width: {
      type: [String, Number],
      default: 250
    },
    placement: {
      type: String,
      default: 'top'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    popperClass: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      rules: {
        reimburseSerialNumber: [{
          required: true,
          message: '请输入退款流水号',
          trigger: 'change'
        }],
        slip: [{
          required: true,
          message: '请上传退款回单',
          trigger: 'change'
        }]
      },
      form: {
        slip: ''
      },
      subInfo: {},
      searchLoading: false,
      adminId: util.cookies.get("uuid") || ""
    };
  },
  watch: {
    'form.reimburseSerialNumber': {
      handler: function handler(nVal) {
        if (!(nVal !== null && nVal !== void 0 && nVal.trim())) {
          this.subInfo = {};
        }
      },
      immediate: true
    }
  },
  computed: {
    isAli: function isAli() {
      return this.form.dataSource === 'ALIPAY';
    }
  },
  methods: {
    formatThousands: formatThousands,
    search: function search() {
      var _this = this;
      if (!this.form.reimburseSerialNumber) return this.$message.warning("请输入退款流水号");
      this.searchLoading = true;
      this.$api.queryBankDetailByCode({
        transactionNo: this.form.reimburseSerialNumber
      }).then(function (res) {
        if (res.code === 200) {
          _this.subInfo = res.data;
        }
      }).finally(function () {
        _this.searchLoading = false;
      }).catch(function (err) {
        _this.subInfo = {};
      });
    },
    show: function show(row) {
      this.isEdit = false;
      this.form = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(row))), this.form);
      if (this.form.certificateUrl) this.form.slip = this.form.certificateUrl;
      if (this.form.reimburseSerialNumber) {
        this.search();
      }
      this.visible = true;
    },
    edit: function edit(row) {
      this.isEdit = true;
      this.form = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(row))), this.form);
      if (this.form.dataSource === 'ALIPAY' && this.form.refundProof) this.form.slip = this.form.refundProof;
      if (this.form.reimburseSerialNumber) {
        this.search();
      }
      this.visible = true;
    },
    cancel: function cancel() {
      var _this2 = this;
      this.visible = false;
      this.$emit('cancel');
      this.$nextTick(function () {
        _this2.$refs['ruleForm'].resetFields();
        _this2.form = {};
        _this2.subInfo = {};
        _this2.searchLoading = false;
      });
    },
    save: function save() {
      var _this3 = this;
      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var params = {
            id: _this3.form.id,
            operationType: "refund",
            adminId: _this3.adminId,
            reimburseSerialNumber: _this3.form.reimburseSerialNumber
          };
          if (_this3.isAli) {
            params.certificateUrl = _this3.form.slip;
          } else {
            params.certificateUrl = _this3.subInfo.url;
          }
          console.log(params, 'paramsparams');
          debugger;
          if (_this3.isEdit) {
            var data = {
              id: _this3.form.id,
              adminId: _this3.adminId,
              reimburseSerialNumber: _this3.form.reimburseSerialNumber
            };
            if (_this3.isAli) {
              data.certificateUrl = _this3.form.slip;
            }
            var res = _this3.$api.updateCompanyDepositOrder(data).then(function (res) {
              if (res.code == 200) {
                _this3.$message.success("操作成功");
              }
              _this3.$emit('confirm', _this3.form);
              _this3.visible = false;
            }).finally(function () {
              _this3.loading = false;
            });
            return;
          }
          _this3.$api.updateDepositRefunded(params).then(function (res) {
            if (res.code === 200) {
              _this3.$message.success("押金退还成功！");
            }
            _this3.$emit('confirm', _this3.form);
            _this3.visible = false;
          }).finally(function () {
            _this3.loading = false;
          });
        }
      });
    }
  }
};